import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationTH from './locales/th/translation.json';



// the translations
// (tip move them in a JSON file and import them)

export const resources = {
  en: {
    translation: { ...translationEN },
  },
  th: {
    translation: { ...translationTH },
  },
};

export type SupportedLngType = keyof typeof resources;

const languageDetector = new LanguageDetector(undefined, {
  order: ['localStorage', 'navigatorCustom'],
  caches: ['localStorage'],
  lookupLocalStorage: 'lang',
});
languageDetector.addDetector({
  name: 'navigatorCustom',

  lookup(options: any) {
    let language: string = (window.navigator as any || {} as any).userLanguage || window.navigator.language;
    language = language.replace('_', '-').split('-')[0];
    const supportedLang = Object.keys(resources);
    return supportedLang.includes(language) ? language : supportedLang[0];
  }
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(languageDetector)
  .init({
    resources,
    fallbackLng: 'th',
    supportedLngs: Object.keys(resources),
    load: 'languageOnly',
    interpolation: {
      escapeValue: false, // react already safes from xss,
      format: function (value, format, lng) {
        if (format === 'thousand-separator' && !isNaN(value)) return new Intl.NumberFormat("en-US").format(value);
        return value;
      }
    },
  });

export default i18n;